import React, { useState } from 'react';
import './Home.css';
import ResumePDF from './resources/Daniel_Korkut_Resume (11).pdf';
import ProfileImage from './resources/Photo_of_me.jpg'; // optional if using import

const Home = () => {
  const [isImageExpanded, setIsImageExpanded] = useState(false);

  return (
    <>
      {/* Hero Section */}
      <section className="hero-section" id="home">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">Daniel Korkut</h1>
            <h2 className="hero-subtitle">Software Engineer</h2>
            <p className="hero-tagline">
              Ambitious, hard-working, team player, with a drive to solve real problems
            </p>
            <div className="hero-cta">
              <a href="#contact" className="hero-button">Contact Me</a>
              <a href={ResumePDF} className="hero-button secondary" target="_blank" rel="noopener noreferrer">View Résumé</a>
            </div>
            <div className="hero-social">
              <a href="http://www.linkedin.com/in/daniel-korkut-592986237" className="social-link linkedin" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a href="https://github.com/dmkorkut" className="social-link github" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </a>
              <a href="mailto:danielmkorkut@gmail.com" className="social-link email" aria-label="Email">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
              </a>
            </div>
          </div>

          <div className="hero-image-container">
            <img
              src={ProfileImage}
              alt="Daniel Korkut"
              className="hero-image"
              onClick={() => setIsImageExpanded(true)}
            />
          </div>
        </div>
      </section>

      {/* Modal for Expanded Image */}
      {isImageExpanded && (
        <div className="image-modal" onClick={() => setIsImageExpanded(false)}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={() => setIsImageExpanded(false)}>×</button>
            <img
              src={ProfileImage}
              alt="Expanded Daniel Korkut"
              className="expanded-image"
            />
          </div>
        </div>
      )}

      {/* Summary Section */}
      <section className="summary-section" id="summary">
        <div className="home-tab-wrapper">
          <div className="home-container no-select">
            <h1 className="home-title">Summary</h1>
            <p className="home-summary">
              Aspiring data and software professional with a strong academic foundation in software engineering (Dean's List), practical experience working on AI-driven projects, and a love of statistics and machine learning. As a former varsity athlete and active student club member, I bring a strong work ethic, team-first mindset, and strategic
              ability to solve problems in any situation. I thrive in settings where I can develop creative solutions and have a significant impact because I'm naturally cooperative and curious. Currently seeking an entry-level position in analytics, applied AI, data engineering, or full stack development.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;






